import { getDriverName, formatRelativeTime } from './DriverPopup.utils';
import { StatusIndicator } from './StatusIndicator';
import { ActiveDriver } from '../models';
import { TruckIcon } from './TruckIcon';
import { ClockIcon } from './ClockIcon';
import { SpeedIcon } from './SpeedIcon';
import { BatteryIcon } from './BatteryIcon';

interface DriverMapLabelProps {
  driver: ActiveDriver;
}

export const DriverMapLabel = ({ driver }: DriverMapLabelProps) => {
  const driverName = getDriverName(driver);
  const lastUpdate = driver.updatedAt || driver.createdAt;

  return (
    <div className='absolute top-3 left-3 bg-white px-4 py-2.5 rounded-lg shadow-lg border border-gray-200 z-[1000]'>
      <div className='flex items-center gap-2 mb-1.5'>
        <TruckIcon width={20} height={20} className='flex-shrink-0' />
        <p className='text-base font-bold text-gray-900 leading-tight'>
          {driverName}
        </p>
      </div>
      <StatusIndicator status={driver.status} />

      {driver.speed !== undefined && (
        <div className='flex items-center gap-1.5 mt-1.5'>
          <SpeedIcon width={14} height={14} className='text-blue-500' />
          <p className='text-sm text-gray-700 font-medium'>
            {driver.speed.toFixed(1)} km/h
          </p>
        </div>
      )}

      {driver.batteryLevel !== undefined && (
        <div className='flex items-center gap-1.5 mt-1.5'>
          <BatteryIcon width={14} height={14} level={driver.batteryLevel} />
          <p className='text-sm text-gray-700 font-medium'>
            {(driver.batteryLevel * 100).toFixed(0)}%
          </p>
        </div>
      )}

      {lastUpdate && (
        <div className='flex items-center gap-1.5 mt-1'>
          <ClockIcon width={12} height={12} className='text-gray-500' />
          <p className='text-xs text-gray-500'>
            {formatRelativeTime(lastUpdate)}
          </p>
        </div>
      )}
    </div>
  );
};
